import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { Paragraph, Button } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { 
  APPLICATION_MODE_NEW, 
  ROUTE_PATH
} from "../../../app/constants";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";

export const ActiveLicenceConfirmationView = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;

  const title = "Active Broker licence.";
  const p1Text = `Does the new ${isPrincipalBroker ? 'principal broker' : 'compliance officer'}, have an active broker licence.` ;

  const handleNext = (confirmRole) => () => {

    if(confirmRole) {
      dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CURRENT_MRA_NUMBER}`));
    } else {
      dispatch(push(`/${application}${ROUTE_PATH.MRA_PREVIOUSLY_LICENCED_MORTGAGE_BROKER}`));
    }
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props} 
          applicationType={applicationTypeFromLicenceSubType(licencingSubType)} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      <div className="row topMarginLarge bottomMarginLarger">
        <div className="col-xs-12 col-lg-8">
          <Paragraph 
            text={[p1Text]}
          />
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3 has-error">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
